import _Button from "@mui/material/Button";
import _Divider from "@mui/material/Divider";
import _DialogTitle from "@mui/material/DialogTitle";
import _Dialog from "@mui/material/Dialog";
import _DialogContent from "@mui/material/DialogContent";
import _Fab from "@mui/material/Fab";
import _Grid from "@mui/material/Grid";
import _Typography from "@mui/material/Typography";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import _useMediaQuery from "@mui/material/useMediaQuery";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { css, styled } from 'styled-components';
import appsImage from '../../assets/images/apps.png';
import geoveloLogo from '../../assets/images/geovelo-logo-text.svg';
import { useSignIn } from '../../hooks';
import { AppleIcon, GoogleIcon } from '../icons';
import SignInForm from './sign-in-form';
import SignUpForm from './sign-up-form';
export function SignInDialog({
  widgetConfig,
  onRegistered,
  onSignedIn,
  onClose,
  ...props
}) {
  const [displayedForm, displayForm] = useState('sign-in');
  const {
    t,
    i18n: {
      language: currentLanguage
    }
  } = useTranslation();
  const theme = useTheme();
  const isSmall = _useMediaQuery(theme.breakpoints.down('md'));
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    googleSignIn,
    appleSignIn
  } = useSignIn();
  useEffect(() => {
    if (props.open) {
      displayForm('sign-in');
    }
  }, [props.open]);
  function close(user) {
    if (displayedForm === 'sign-in') onSignedIn(user);else onRegistered(user);
  }
  async function handleGoogleSignIn() {
    try {
      const user = await googleSignIn(currentLanguage, displayedForm === 'sign-in');
      close(user);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.sign_in_dialog.server_error'));
    }
  }
  async function handleAppleSignIn() {
    try {
      const user = await appleSignIn(currentLanguage, displayedForm === 'sign-in');
      close(user);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.sign_in_dialog.server_error'));
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "md",
    onClose: () => onClose(),
    scroll: "paper",
    slotProps: {
      paper: {
        sx: {
          borderRadius: 4
        }
      }
    }
  }, props), /*#__PURE__*/React.createElement(StyledDialogTitle, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, {
    fontSize: "small"
  })))), /*#__PURE__*/React.createElement(_DialogContent, null, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(StyledLogo, {
    alt: "Logo Geovelo",
    src: geoveloLogo
  }), /*#__PURE__*/React.createElement(_Grid, {
    container: true,
    direction: isSmall ? 'column-reverse' : 'row',
    spacing: 4,
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Grid, {
    size: {
      xs: 12,
      md: 6
    }
  }, /*#__PURE__*/React.createElement(_Typography, {
    gutterBottom: true,
    color: "primary",
    variant: "h5"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.sign_in_dialog.title"
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.sign_in_dialog.description"
  })), /*#__PURE__*/React.createElement(StyledAppsImage, {
    alt: "Geovelo apps",
    src: appsImage
  })), /*#__PURE__*/React.createElement(_Grid, {
    size: {
      xs: 12,
      md: 6
    }
  }, /*#__PURE__*/React.createElement(SSOButtonsWrapper, null, /*#__PURE__*/React.createElement(_Fab, {
    disableRipple: true,
    onClick: handleAppleSignIn,
    style: {
      backgroundColor: '#000',
      color: '#fff',
      boxShadow: 'none'
    }
  }, /*#__PURE__*/React.createElement(AppleIcon, {
    color: "inherit"
  })), /*#__PURE__*/React.createElement(_Fab, {
    disableRipple: true,
    onClick: handleGoogleSignIn,
    style: {
      backgroundColor: 'white',
      border: '1px solid #ccc',
      boxShadow: 'none'
    }
  }, /*#__PURE__*/React.createElement(GoogleIcon, null))), /*#__PURE__*/React.createElement(FormWrapper, null, displayedForm === 'sign-in' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledSignInForm, {
    onSignedIn: onSignedIn
  }), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement(_Typography, {
      color: "primary",
      component: "a",
      href: "https://geovelo.app/forgot-password/",
      key: 0,
      target: "_blank",
      variant: "caption"
    })],
    i18nKey: "commons.sign_in_form.forgot_password"
  })), /*#__PURE__*/React.createElement(StyledDivider, null), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.sign_in_dialog.not_registered"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    onClick: () => displayForm('sign-up'),
    size: "medium",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.sign_up"
  }))), displayedForm === 'sign-up' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledSignUpForm, {
    onRegistered: onRegistered,
    widgetConfig: widgetConfig
  }), /*#__PURE__*/React.createElement(StyledDivider, null), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.sign_in_dialog.already_registered"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    onClick: () => displayForm('sign-in'),
    size: "medium",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.sign_in"
  }))))))))));
}
const StyledDialogTitle = styled(_DialogTitle)`
  display: flex;
  justify-content: flex-end;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
`;
const StyledLogo = styled.img`
  align-self: center;
  margin-bottom: 48px;
  width: 96px;
`;
const StyledAppsImage = styled.img`
  margin-top: 16px;
  width: calc(100% - 32px);
`;
const SSOButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 16px;
`;
const FormWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const formStyle = css`
  margin: 0 auto 16px;
  max-width: 350px;
  width: 100%;
`;
const StyledSignInForm = styled(SignInForm)`
  ${formStyle};
`;
const StyledDivider = styled(_Divider)`
  && {
    margin: 16px 0;
    width: 100%;
  }
`;
const StyledButton = styled(_Button)`
  && {
    margin-top: 8px;
    max-width: 350px;
    width: 100%;
  }
`;
const StyledSignUpForm = styled(SignUpForm)`
  ${formStyle};
`;